export enum SwitchViewMode {
  Switch = 0,
  MachineSearch = 1,
  Tonnage = 2,
}
